import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { de, enGB, es, fr, nl, sv } from 'date-fns/locale';

export const useLocale = () => {
  const { i18n } = useTranslation();
  const [locale, setLocale] = useState<Locale | undefined>();

  useEffect(() => {
    switch (i18n.language) {
      case 'nl':
        setLocale(nl);
        break;
      case 'en':
        setLocale(enGB);
        break;
      case 'de':
        setLocale(de);
        break;
      case 'sv':
        setLocale(sv);
        break;
      case 'fr':
        setLocale(fr);
        break;
      case 'es':
        setLocale(es);
        break;
      default:
        setLocale(undefined);
    }
  }, [i18n.language]);

  return locale;
};
